export const userReviews = [
  {
    id: "1",
    name: "吃瓜群众小王",
    username: "@chigua_xiaowang",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20minimalist%20profile%20avatar%20with%20soft%20warm%20lighting%2C%20clean%20background%2C%20neutral%20expression%2C%20professional%20headshot%20style%2C%20warm%20beige%20tones&width=120&height=120&seq=avatar-01&orientation=squarish",
    content: "这个网站真的太顶了！每天必刷，吃瓜吃到饱。消息更新速度比微博还快，而且很多独家内容确实是在别的地方看不到的。身边的朋友都被我安利了，现在大家都是铁粉。",
    rating: 5,
  },
  {
    id: "2",
    name: "深夜吃瓜少女",
    username: "@shenye_guagua",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20minimalist%20female%20profile%20avatar%2C%20soft%20warm%20lighting%2C%20clean%20neutral%20background%2C%20professional%20headshot%20style%2C%20warm%20cream%20tones&width=120&height=120&seq=avatar-02&orientation=squarish",
    content: "已经连续签到30天了，可以说是吃瓜界的天花板了。一区二区的分类也很清晰，想看明星八卦就去一区，想看网红翻车就去二区，非常方便。希望越做越好！",
    rating: 5,
  },
  {
    id: "3",
    name: "娱乐圈老司机",
    username: "@ylq_laosiji",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20minimalist%20male%20profile%20avatar%20with%20warm%20lighting%2C%20clean%20background%2C%20professional%20headshot%20style%2C%20neutral%20expression%2C%20beige%20tones&width=120&height=120&seq=avatar-03&orientation=squarish",
    content: "混迹各种吃瓜群多年，51黑料网是信息最全、更新最快的平台。很多瓜都是这里先爆出来的，然后才传到微博抖音。小编的消息源是真的硬！",
    rating: 5,
  },
  {
    id: "4",
    name: "吃瓜不嫌事大",
    username: "@chigua_buxian",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20minimalist%20profile%20avatar%20with%20warm%20soft%20lighting%2C%20clean%20background%2C%20neutral%20headshot%2C%20professional%20style%2C%20cream%20beige%20tones&width=120&height=120&seq=avatar-04&orientation=squarish",
    content: "每日大赛板块是精髓！每天都有不同的热门话题，评论区也很有意思，大家吃瓜的氛围特别好。虽然有时候瓜不一定保熟，但看的开心最重要。",
    rating: 4,
  },
  {
    id: "5",
    name: "媒体人老张",
    username: "@meitiren_zhang",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20minimalist%20male%20profile%20avatar%2C%20warm%20soft%20lighting%2C%20clean%20neutral%20background%2C%20professional%20headshot%20style%2C%20beige%20cream%20tones&width=120&height=120&seq=avatar-05&orientation=squarish",
    content: "作为同行，说实话挺佩服的。很多信息我们传统媒体拿到了都不敢发，51黑料网是真的敢爆。虽然有时候措辞比较娱乐化，但核心信息基本都是准的。业内很多人都在这蹲料。",
    rating: 4,
  },
  {
    id: "6",
    name: "八卦研究员",
    username: "@bagua_research",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20minimalist%20female%20profile%20avatar%2C%20warm%20soft%20studio%20lighting%2C%20clean%20background%2C%20professional%20headshot%2C%20neutral%20expression%2C%20cream%20tones&width=120&height=120&seq=avatar-06&orientation=squarish",
    content: "关注51黑料网半年了，信息量大而且更新频繁。特别是每篇文章都标注了来源和时间线，看起来很专业。唯一的小建议是希望增加一个搜索功能，有时候想找之前的旧瓜不太方便。",
    rating: 4,
  },
];